import { dropdownTriggerClassname } from "app/components/Dropdown";
import TicketTypeIcon from "app/components/TicketTypeIcon";
import CustomTooltip from "app/components/Tooltip";
import CommonTicketTypeSelection from "app/containers/Features/components/CommonTicketTypeSelection";
import { getTicketTypeByIds } from "app/containers/Features/containers/TeamSettings/container/Projects/container/WorkItems/helper";
import { ITicketTypes } from "app/containers/Features/containers/TeamSettings/container/Projects/container/WorkItems/types";
import { selectTicketTypes } from "app/redux/selector";
import clsx from "clsx";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";

interface CustomProps {
  value: string;
  onUpdate: (id: string) => void;
}

const TicketTypeSelection: React.FC<CustomProps> = ({ value, onUpdate }) => {
  const ticketTypes = useSelector(selectTicketTypes);

  const ticketType = useMemo(() => {
    return getTicketTypeByIds(ticketTypes, value)[0];
  }, [ticketTypes, value]);
  const updateValue = (data: ITicketTypes) => {
    // update form out side parent component
    onUpdate(data._id);
  };
  return (
    <div className="relative w-full">
      <CommonTicketTypeSelection
        trigger={
          <button
            className={clsx(
              "flex items-center justify-between w-full p-[6px] rounded-md",
              dropdownTriggerClassname,
            )}
          >
            <CustomTooltip
              text="Set ticket type"
              className="flex items-center "
              position="left"
            >
              <div className="flex items-center gap-1 w-full">
                <TicketTypeIcon
                  iconName={ticketType?.icon as string}
                  size={16}
                />
                <span className="text-sm font-normal text-secondary">
                  {ticketType?.name}
                </span>
              </div>
            </CustomTooltip>
          </button>
        }
        isHeader="ticket types"
        value={value}
        setValue={updateValue}
        showEndIcon
      />
    </div>
  );
};

export default TicketTypeSelection;
